// extracted by mini-css-extract-plugin
module.exports = {"theme":"Theme_theme__3Per8","input":"Theme_input__N20-j","inner":"Theme_inner__2t4KT","box":"Theme_box__1Knkl","themeBig":"Theme_themeBig__2sA-m"};